var _path, _path2, _path3;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPeso = function SvgPeso(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.62903 10.7143L5 30H29L25.371 10.7143H17.9677V8.78571H25.9516L28.8548 3H26.6774L24.7419 6.85714H9.25806L7.32258 3H5.14516L8.04838 8.78571H16.0323V10.7143H8.62903ZM23.7742 12.6429L26.6774 28.0714H7.32258L10.2258 12.6429H23.7742Z",
    fill: "#002445"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 14.5714C13.8064 14.5714 11.1935 17.175 11.1935 20.3571C11.1935 23.5393 13.8064 26.1429 17 26.1429C20.1935 26.1429 22.8064 23.5393 22.8064 20.3571C22.8064 17.175 20.1935 14.5714 17 14.5714ZM17 24.2143C14.871 24.2143 13.129 22.4786 13.129 20.3571C13.129 18.2357 14.871 16.5 17 16.5C19.129 16.5 20.871 18.2357 20.871 20.3571C20.871 22.4786 19.129 24.2143 17 24.2143Z",
    fill: "#002445"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4839 17.4643H16.5161V20.3571H17.4839V17.4643Z",
    fill: "#002445"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPeso, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/peso.3e6c4b4a.svg";
export { ForwardRef as ReactComponent };